import { defaultOption } from 'shared/form/select/option-helpers';

export const defaultBillingData: any = {
  address1: '',
  address2: '',
  country: 'US',
  city: '',
  state: null,
  zipCode: '',
  creditCard: '',
  cvv: '',
  expMonth: defaultOption.option,
  expYear: defaultOption.option,
  cardholderName: '',
};
